<template>
    <div class="operatePage">
        <LeftTree />
        <RightContent />
    </div>
</template>

<script>
import LeftTree from '../LeftTree.vue';
import RightContent from './RightContent.vue'
export default {
    components: {
        LeftTree,
        RightContent
    }
}
</script>

<style lang="scss" scoped>
.operatePage{
    display: flex;
    height: 100%;
}
</style>